import { useEffect, useState } from "react";
import { MeterGroup } from 'primereact/metergroup';
import "./MeaAttendancesProgressBar.css";

const MeaAttendancesProgressBar2 = ({
  attendances,
  showValues = true,
  showLegends = true,
  showMeter = true,
}) => {

  const [pourcentages, setPourcentages] = useState([]);

  useEffect(() => {
    if (attendances !== undefined) {
      setPourcentages(calculateAttendancesPourcentage(attendances));
    }
  }, [attendances]);

  const calculateAttendancesPourcentage = (attendances) => {
    let total = 0;
    let present = 0;
    let presentAndLate = 0;
    let absent = 0;
    let late = 0;
    //
    attendances?.forEach(function (item, i) {
      total++;
      if (item.status === "PRESENT") {
        present++;
        presentAndLate++;
      } else if (item.status === "ABSENT") {
        absent++;
      } else if (item.status === "LATE") {
        late++;
        presentAndLate++;
      }
    });
    return [{ label: 'Présence', originalValue: presentAndLate, value: total > 0 ? (present * 100) / total : 0, color: 'var(--green-500)' },
    { label: 'Retards', originalValue: late, value: total > 0 ? (late * 100) / total : 0, color: 'var(--orange-500)' },
    { label: 'Absences', originalValue: absent, value: total > 0 ? (absent * 100) / total : 0, color: 'var(--red-500)' }];
  };

  const labelList = ({ values }) => (
    <div className="flex flex-wrap gap-1">
      {values.map((item, index) => (
        <div className="flex-1 p-1 pt-2" key={index}>
          <div className="flex gap-1">
            <div className="flex flex-column gap-1">
              <span className="text-secondary text-sm">{item.label}</span>
              <span className="font-bold text-lg" style={{ color: item.color }}>{item.originalValue}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div className="bg-white flex justify-content-start pl-3 pb-3 pr-3 w-full">
      {!showMeter && labelList({ values: pourcentages })}
      {showMeter && <MeterGroup values={pourcentages} labelList={labelList} className="pt-3 w-full" />}
    </div>
  );
};

export default MeaAttendancesProgressBar2;
